export default __webpack_public_path__ + "static/media/summerchallenge07.08d2637a.jpg";